<template>
  <div>
    <div class="bg-secondary-3 rounded p-3 px-4">
      <div class="row">
        <icon-view
          class="col"
          icon="fas fa-file-search"
          icon-background="#fff"
          icon-color="#ff7058"
          icon-size="14px"
          title="Búsqueda de Estudiante"
        />
      </div>
      <validation-observer ref="searchServiceRef">
        <div class="row mt-3">
          <div class="col-12 col-md-4 mb-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="search.academicYear"
                custom-error-msg="Favor seleccion un año académico."
                :error="errors[0]"
                fieldkey="id"
                fieldname="description"
                :options="years"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="search.SieOrReferralNumber"
                custom-error-msg
                :error="errors[0]"
                icon="fa fa-search orange-icon"
                :left-icon="true"
                placeholder="Escribir Número de SIE o Referido"
              />
              <custom-error
                v-if="errors[0]"
                message="Favor entrar un número de referido o SIE."
                variant="no-border ml-4"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 search-button-container">
            <action-button
              class="success"
              i="fa fa-search"
              @click="onSearchHandler"
            >
              Buscar
            </action-button>
          </div>
        </div>
      </validation-observer>

      <custom-separator
        v-if="students.length > 0 && searched"
        class="pt-3 my-4"
        text="Resultado de Búsqueda"
      />
      <div ref="studentsList">
        <div
          v-for="(item, index) in students"
          :key="`${studentItemsClassname}-${index}-${Math.random()}`"
          class="row student-row bg-white p-3 rounded mb-3"
          :class="`${studentItemsClassname}-${index}`"
        >
          <div class="col-6 col-md-2 mb-3 d-none d-md-block">
            <div class="student-row__label">Nombre del Estudiante:</div>
            <span class="student-row__info">
              {{ item.studentSieId }} - {{ item.studentFullName }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 d-none d-md-block">
            <div class="student-row__label">
              Referido:
            </div>
            <span class="student-row__info">
              {{ item.referralNumber }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 d-none d-md-block">
            <div class="student-row__label">
              Vigencia:
            </div>
            <span class="student-row__info text-nowrap">
              {{ formatDate(item.effectiveDateFrom.split(' ')[0]) }} -
              {{ formatDate(item.effectiveDateTo.split(' ')[0]) }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 d-block d-md-none">
            <div class="student-row__label">Nombre del Estudiante:</div>
            <span class="student-row__info">
              {{ item.studentSieId }} - {{ item.studentFullName }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 d-block d-md-none">
            <div class="student-row__label">
              Referido:
            </div>
            <span class="student-row__info">
              {{ item.referralNumber }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 d-block d-md-none">
            <div class="student-row__label">
              Vigencia:
            </div>
            <span class="student-row__info">
              {{ formatDate(item.effectiveDateFrom.split(' ')[0]) }}
              {{ formatDate(item.effectiveDateTo.split(' ')[0]) }}
            </span>
          </div>

          <div class="col-6 col-md-2 mb-3">
            <div class="student-row__label">
              Tipo de Servicio:
            </div>
            <span class="student-row__info">
              {{ item.disciplineTypeName }}
            </span>
          </div>
          <div class="col-12 col-md-2 mb-3">
            <div class="student-row__label">
              Proveedor:
            </div>
            <span class="student-row__info">
              {{ item.companyName }}
            </span>
          </div>
          <div
            class="col-12 col-md-2 mt-3 d-flex justify-content-center align-items-start"
          >
            <action-button
              class="outline-success py-1 w-100"
              i="fa fa-check"
              @click="onSelectHandler(item, index)"
            >
              Seleccionar
            </action-button>
          </div>
        </div>
      </div>
    </div>

    <custom-separator
      v-if="students.length === 0 && searched"
      class="pt-3 my-4"
      text="Resultado de Búsqueda"
    />
    <div
      v-if="students.length === 0 && searched"
      class="bg-white rounded pt-1 pb-3"
    >
      <custom-result-not-found text="Su búsqueda no produjo resultado." />
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomError from 'custom-error';
import CustomDropDown from 'custom-drop-down';
import alertMixin from 'utils/mixins/alert.mixin.js';
import CustomResultNotFound from 'custom-result-not-found';
import CustomSeparator from 'custom-separator';
import IconView from 'icon-view';
import moment from 'moment';
import { getUmesrAcademicYears, getUmesrFindings } from '@/modules/umesr/api';

const studentItemsClassname = 'student-service-item';

const searchDefault = {
  SieOrReferralNumber: '',
  academicYear: null,
};

export default {
  name: 'SearchReferences',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    CustomError,
    CustomResultNotFound,
    CustomSeparator,
    IconView,
  },
  mixins: [alertMixin],
  data: () => ({
    students: [],
    years: [],
    searched: false,
    search: {
      ...searchDefault,
    },
    studentItemsClassname,
  }),
  created() {
    getUmesrAcademicYears().then(({ data }) => (this.years = data ? data : []));
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
    },
    async onSearchHandler() {
      const isValid = await this.$refs.searchServiceRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      this.searched = true;

      const params = {
        academicYearId: this.search.academicYear?.id,
        SieOrReferralNumber: this.search.SieOrReferralNumber,
      };
      const { data } = await getUmesrFindings(params);
      this.students = data ? [...data] : [];
    },
    clear() {
      this.students = [];
      this.search = { ...searchDefault };
    },
    onSelectHandler(student) {
      this.clear();
      this.$emit('onSelect', student);
    },
  },
};
</script>
<style lang="scss" scoped>
.student-row {
  &__label {
    font-weight: normal;
    font-size: 14px;
    color: #727272;
  }

  &__info {
    font-weight: normal;
    font-size: 16px;
    color: #11291b;
  }

  &.selected {
    border: 4px solid #2db782;
  }
}

@media screen and (max-width: 780px) {
  .search-button-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
